module.exports = __webpack_public_path__ + "static/media/lock-is-correct.8d3930ed.mp3";